package com.exura.pages.login

import com.exura.features.localization.domain.model.BasicLangSet
import com.exura.features.localization.domain.model.Language
import com.exura.features.localization.domain.model.Localization

interface LoginLang {
    val fields: Fields
    val messages: Messages
    val actions: Actions
    val errors: Errors
    
    val pageTitle: String
    
    interface Fields {
        val emailAddress: String
        val password: String
    }
    
    interface Messages {
        val cannotLogin: String
        val writeToUs: String
        val wantToStartWithUs: String
    }
    
    interface Actions {
        val login: String
        val createAccount: String
    }
    
    interface Errors {
        val passwordCantBeEmpty: String
    }
}

data object LoginPolish : LoginLang {
    override val fields = Fields
    override val messages = Messages
    override val actions = Actions
    override val errors = Errors
    
    override val pageTitle: String = "Zaloguj się do konta lekarza"
    
    data object Fields : LoginLang.Fields {
        override val emailAddress: String = "Adres e-mail"
        override val password: String = "Hasło"
    }
    
    data object Messages : LoginLang.Messages {
        override val cannotLogin: String = "Nie można się zalogować?"
        override val writeToUs: String = "Napisz do nas"
        override val wantToStartWithUs: String = "Chcesz zacząć z nami?"
    }
    
    data object Actions : LoginLang.Actions {
        override val login: String = "Zaloguj się"
        override val createAccount: String = "Utwórz konto"
    }
    
    data object Errors : LoginLang.Errors {
        override val passwordCantBeEmpty: String = "Hasło nie może być puste"
    }
}

data object LoginEnglish : LoginLang {
    override val fields = Fields
    override val messages = Messages
    override val actions = Actions
    override val errors = Errors
    
    override val pageTitle: String = "Sign in to your doctor account"
    
    data object Fields : LoginLang.Fields {
        override val emailAddress: String = "Email Address"
        override val password: String = "Password"
    }
    
    data object Messages : LoginLang.Messages {
        override val cannotLogin: String = "Cannot login?"
        override val writeToUs: String = "Write to us"
        override val wantToStartWithUs: String = "Want to start with us?"
    }
    
    data object Actions : LoginLang.Actions {
        override val login: String = "Login"
        override val createAccount: String = "Create Account"
    }
    
    data object Errors : LoginLang.Errors {
        override val passwordCantBeEmpty: String = "Password can't be empty"
    }
}

private val loginLangSet = BasicLangSet<LoginLang>(
    mapOf(
        Language.POLISH to LoginPolish,
        Language.ENGLISH to LoginEnglish,
    )
)

val loginLocalization = Localization<LoginLang>(loginLangSet)
